var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('h1',{staticClass:"page-title"},[_vm._t("default")],2),_c('LoadingSuccessSpinner'),(_vm.getFlashMessage.message)?_c('b-alert',{attrs:{"show":"","dismissible":"","variant":_vm.getFlashMessage.type}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.getFlashMessage.message)}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }